export var animation = {
    WAVES: "waves",
    PULSE: "pulse"
};
export var variant = {
    RECT: "rect",
    CIRCLE: "circle"
};
